import React from 'react'
import { useSelector } from 'react-redux'
import clsx from 'clsx'
import { TextField, InputAdornment } from '@material-ui/core'
import { Person } from '@material-ui/icons'

import { Alert, CustomButton } from 'components'
import { useEsqueceuSenhaForm } from '../../hooks/useEsqueceuSenhaForm'
import useStyles from './Formulario.styles'

export const Formulario = (props) => {
  const { className, ...rest } = props
  const classes = useStyles()
  const usuarios = useSelector((state) => state.usuarios)

  const {
    formState,
    isLoading,
    handleChange,
    handleSubmit,
    hasError,
  } = useEsqueceuSenhaForm()

  return (
    <form {...rest} className={clsx(classes.root, className)} onSubmit={handleSubmit}>
      {/* Alerta de erro vindo da Store Redux */}
      <div className={classes.alert}>
        {usuarios.solicitar_redefinir_senha_erro ? (
          <Alert 
            variant="error" 
            message="As informações não correspondem com as informações cadastradas." 
          />
        ) : null}
      </div>

      <div className={classes.fieldsContainer}>
        {/* Campo CPF */}
        <TextField
          id="cpf"
          name="cpf"
          label="CPF"
          variant="outlined"
          fullWidth
          required
          className={classes.fieldWrapper}
          value={formState.values.cpf || ''}
          onChange={handleChange}
          error={hasError('cpf')}
          helperText={hasError('cpf') ? 'Digite um CPF válido' : null}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start" className={classes.iconAdornment}>
                <Person fontSize="small" />
              </InputAdornment>
            ),
          }}
        />
      </div>

      {/* Botão de envio customizado padrão SIGEP */}
      <CustomButton
        type="submit"
        colorType="primary"
        variant="contained"
        fullWidth
        className={classes.submitButton}
        disabled={!formState.isValid || !formState.cpfValido || isLoading}
        isLoading={isLoading}
        size="large"
      >
        Recuperar senha
      </CustomButton>
    </form>
  )
}
